import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  class: "sttts-title"
};
const _hoisted_3 = {
  class: "sttts-body"
};
const _hoisted_4 = {
  class: "appr-name"
};
const _hoisted_5 = {
  class: "appr-state-div border-blue"
};
const _hoisted_6 = {
  class: "appr-val text-blue"
};
const _hoisted_7 = {
  class: "appr-state-div border-green"
};
const _hoisted_8 = {
  class: "appr-val text-green"
};
const _hoisted_9 = {
  class: "appr-state-div border-red"
};
const _hoisted_10 = {
  class: "appr-val text-red"
};
const _hoisted_11 = {
  class: "appr-state-div border-yellow"
};
const _hoisted_12 = {
  class: "appr-val text-yellow"
};
const _hoisted_13 = {
  class: "daiban-title"
};
const _hoisted_14 = {
  class: "daiban-title"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_tag = _resolveComponent("el-tag");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_badge = _resolveComponent("el-badge");
  const _component_el_popover = _resolveComponent("el-popover");
  const _component_el_scrollbar = _resolveComponent("el-scrollbar");
  const _component_el_empty = _resolveComponent("el-empty");
  return _ctx.msgList.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_scrollbar, {
    height: "calc(100vh - 154px)"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.msgList, (item, i) => {
      return _openBlock(), _createBlock(_component_el_row, {
        gutter: 24,
        key: i,
        class: _normalizeClass(['todo-div', item.activeStatus == 0 ? 'todo-read' : ''])
      }, {
        default: _withCtx(() => [item.auditSttts && item.auditSttts.length > 0 ? (_openBlock(), _createBlock(_component_el_popover, {
          key: 0,
          placement: "bottom",
          trigger: "hover",
          width: "360"
        }, {
          reference: _withCtx(() => [_createVNode(_component_el_badge, {
            value: item.count,
            max: 99,
            class: "badge-item"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 24,
              onClick: $event => $setup.handleFinish(i),
              class: "todo-item"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_row, {
                class: "msg-row"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_tag, {
                  size: "small"
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name), 1)]),
                  _: 2
                }, 1024), _createElementVNode("span", _hoisted_13, _toDisplayString(item.eventName), 1)]),
                _: 2
              }, 1024), _createVNode(_component_el_row, {
                class: "msg-panel"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(item.eventContent), 1)]),
                _: 2
              }, 1024), _createVNode(_component_el_row, {
                class: "msg-panel"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(item.handleTime), 1)]),
                _: 2
              }, 1024)]),
              _: 2
            }, 1032, ["onClick"])]),
            _: 2
          }, 1032, ["value"])]),
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, "【" + _toDisplayString(item.demandName) + "】素材审核详情", 1), _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.auditSttts, (sttts, index) => {
            return _openBlock(), _createElementBlock("div", {
              class: "sttts-item",
              key: index
            }, [_createElementVNode("div", _hoisted_4, _toDisplayString(sttts.ROLE_NAME), 1), _createElementVNode("div", _hoisted_5, [_cache[0] || (_cache[0] = _createElementVNode("div", {
              class: "appr-title"
            }, "待审核", -1)), _createElementVNode("div", _hoisted_6, _toDisplayString(sttts.APPR0 ? sttts.APPR0 : 0), 1)]), _createElementVNode("div", _hoisted_7, [_cache[1] || (_cache[1] = _createElementVNode("div", {
              class: "appr-title"
            }, "通过", -1)), _createElementVNode("div", _hoisted_8, _toDisplayString(sttts.APPR1 ? sttts.APPR1 : 0), 1)]), _createElementVNode("div", _hoisted_9, [_cache[2] || (_cache[2] = _createElementVNode("div", {
              class: "appr-title"
            }, "驳回", -1)), _createElementVNode("div", _hoisted_10, _toDisplayString(sttts.APPR3 ? sttts.APPR3 : 0), 1)]), _createElementVNode("div", _hoisted_11, [_cache[3] || (_cache[3] = _createElementVNode("div", {
              class: "appr-title"
            }, "保留意见", -1)), _createElementVNode("div", _hoisted_12, _toDisplayString(sttts.APPR2 ? sttts.APPR2 : 0), 1)])]);
          }), 128))])]),
          _: 2
        }, 1024)) : (_openBlock(), _createBlock(_component_el_badge, {
          key: 1,
          value: item.count,
          max: 99,
          class: "badge-item"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 24,
            onClick: $event => $setup.handleFinish(i),
            class: "todo-item"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_row, {
              class: "msg-row"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_tag, {
                size: "small"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name), 1)]),
                _: 2
              }, 1024), _createElementVNode("span", _hoisted_14, _toDisplayString(item.eventName), 1)]),
              _: 2
            }, 1024), _createVNode(_component_el_row, {
              class: "msg-panel"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(item.eventContent), 1)]),
              _: 2
            }, 1024), _createVNode(_component_el_row, {
              class: "msg-panel"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(item.handleTime), 1)]),
              _: 2
            }, 1024)]),
            _: 2
          }, 1032, ["onClick"])]),
          _: 2
        }, 1032, ["value"]))]),
        _: 2
      }, 1032, ["class"]);
    }), 128))]),
    _: 1
  })])) : (_openBlock(), _createBlock(_component_el_empty, {
    key: 1,
    description: "暂无待办事项"
  }));
}